import { focusManager, type QueryClient } from '@tanstack/react-query';
import { availableSpotsKeys } from '../api/available-spots';
import { myParkingSpotsKeys } from '../api/my-parking-spots';

/** Listas que mudam com janela, uso ou troca de condomínio — refetch mesmo se o cache ainda for “fresco”. */
export const parkingListQueryOptions = {
  refetchOnMount: 'always' as const,
  refetchOnWindowFocus: 'always' as const,
  refetchOnReconnect: 'always' as const,
};

export function invalidateParkingLists(queryClient: QueryClient) {
  return Promise.all([
    queryClient.invalidateQueries({ queryKey: availableSpotsKeys.all }),
    queryClient.invalidateQueries({ queryKey: myParkingSpotsKeys.all }),
  ]);
}

/**
 * PWA iOS/Android às vezes não dispara o focus do React Query.
 * visibilitychange + pageshow forçam o refetch das listas ao voltar ao app.
 */
export function bindParkingQueryFocus() {
  if (typeof window === 'undefined') return;

  focusManager.setEventListener((handleFocus) => {
    const notify = (focused: boolean) => {
      if (focused) {
        handleFocus(false);
        handleFocus(true);
        return;
      }
      handleFocus(false);
    };

    const onVisibility = () => {
      notify(document.visibilityState === 'visible');
    };
    const onPageShow = () => notify(true);

    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('focus', onVisibility);
    window.addEventListener('pageshow', onPageShow);

    return () => {
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('focus', onVisibility);
      window.removeEventListener('pageshow', onPageShow);
    };
  });
}
